import React from "react";
import "./Features.css";
import { TranslationContext } from "../TranslationContext";

const Features = () => {
  const { translation } = React.useContext(TranslationContext);

  return (

    <section className="features-section">
      <div className="features-small-container">
      <div className="features-grid">
        <div className="feature-item">
          <div className="feature-card">
            <div className="feature-front">
              <h1 className="feature-title">{translation.featuresH1}</h1>
            </div>
            <div className="feature-back">
              <p className="feature-description">
                {translation.featuresP1}
              </p>
            </div>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-card">
            <div className="feature-front">
              <h1 className="feature-title">{translation.featuresH2}</h1>
            </div>
            <div className="feature-back">
              <p className="feature-description">
                {translation.featuresP2}
              </p>
            </div>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-card">
            <div className="feature-front">
              <h1 className="feature-title">{translation.featuresH3}</h1>
            </div>
            <div className="feature-back">
              <p className="feature-description">
               {translation.featuresP3}
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default Features;
